

const btnList = [
    [
        {
            name:"还原",
            up:require("@/assets/detail/newspapers_button_main_up.png"),
            down:require("@/assets/detail/newspapers_button_main_down.png"),
        },
        {
            name:"放大",
            up:require("@/assets/detail/newspapers_button_big_up.png"),
            down:require("@/assets/detail/newspapers_button_big_down.png"),
        },
        {
            name:"缩小",
            up:require("@/assets/detail/newspapers_button_small_up.png"),
            down:require("@/assets/newspapers_button_small_down.png"),
        },
        {
            name:"左旋90度",
            up:require("@/assets/detail/newspapers_button_left_up.png"),
            down:require("@/assets/detail/newspapers_button_left_down.png"),
        },
        {
            name:"右旋90度",
            up:require("@/assets/detail/newspapers_button_right_up.png"),
            down:require("@/assets/detail/newspapers_button_right_down.png"),
        },
        // {
        //     name:"放大镜",
        //     up:require("@/assets/detail/newspapers_button_magnifier_up.png"),
        //     down:require("@/assets/detail/newspapers_button_magnifier_down.png"),
        // },
        // {
        //     name:"拖动",
        //     up:require("@/assets/detail/newspapers_button_move_up.png"),
        //     down:require("@/assets/detail/newspapers_button_move_down.png"),
        // }
    ],
    [
        {
            name:"首页",
            up:require("@/assets/detail/newspapers_button_first_up.png"),
            down:require("@/assets/detail/newspapers_button_first_down.png"),
        },
        {
            name:"上一页",
            up:require("@/assets/detail/newspapers_button_previous_up.png"),
            down:require("@/assets/detail/newspapers_button_previous_down.png"),
        },
        {
            name:"下一页",
            up:require("@/assets/detail/newspapers_button_next_up.png"),
            down:require("@/assets/detail/newspapers_button_next_down.png"),
        },
        {
            name:"末页",
            up:require("@/assets/detail/newspapers_button_last_up.png"),
            down:require("@/assets/detail/newspapers_button_last_down.png"),
        }
    ]
]

 
module.exports = {
    btnList: btnList , 
};